export enum SalaryType {
  None = 0,
  Full = 1,
  Contract = 2,
}
